import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { BehaviorSubject, from, map, Observable, of, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PermisosGuard implements CanActivate {
    
    constructor(private router: Router, private navigationService: NavigationService) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        const menuRequerido = route.data['menu'] as string;

        // Función para validar si un link es permitido
        const validar = (menuLinks: string[]) => {
            const currentUrl = state.url;
            let permitido = false;

            if (menuRequerido.includes(':')) {
                const base = menuRequerido.split('/:')[0];
                permitido = menuLinks.some(link => link === base || currentUrl.startsWith(link));

            } else {
                permitido = menuLinks.includes(menuRequerido) || menuLinks.some(link => currentUrl.startsWith(link));

            }

            if (!permitido) {
                this.router.navigate(['/home']);
            }

            return permitido;
        };
        
        return this.navigationService.links$.pipe( 
            switchMap(links => {
                if (links.length > 0) {
                    // links cargados en memoria
                    return of(validar(links));
                }else{
                    // si no se encuentran datos en link, se realiza el get de menú
                    return from(this.navigationService.getNavigation()).pipe(
                    switchMap((nav$) => nav$.pipe(
                        map(() => {
                            const links = this.navigationService.getCurrentLinks();
                            return validar(links);
                        })
                    ))
                );
                    
                }
            })
        );
    }
    
}





